import Modal, { type Props as ModalProps } from 'react-modal'
import { Outlet } from 'react-router-dom'

import {
  StContentContainer,
  StFooterContainer,
  StFullScreenModalContainer,
  StHeaderContainer,
} from './FullScreenModalLayout.styled'

import type { ReactNode } from 'react'

import './ModalStyle.css'

type FullScreenModalLayoutProps = {
  header?: ReactNode
  footer?: ReactNode
  children?: ReactNode
  backgroundColor?: string
}

const FullScreenModalLayout = ({
  header,
  footer,
  children,
  backgroundColor,
  ...modalProps
}: FullScreenModalLayoutProps & ModalProps) => {
  return (
    <Modal {...modalProps} closeTimeoutMS={275}>
      <StFullScreenModalContainer backgroundColor={backgroundColor}>
        {header ? <StHeaderContainer>{header}</StHeaderContainer> : null}

        <StContentContainer>{children || <Outlet />}</StContentContainer>

        {footer ? <StFooterContainer>{footer}</StFooterContainer> : null}
      </StFullScreenModalContainer>
    </Modal>
  )
}

export type { FullScreenModalLayoutProps }
export { FullScreenModalLayout }
